import { ConfigService } from "../services/config.service";

export class AuthUser {

    sub: string;
    username: string;
    roles: string[];
    currentCustomer: Customer;
    loginCustomer: Customer;
    exp: number;
    iat: number;
    aud: string;
    iss: string;
    image: string;


    static fromJson(request: string): AuthUser {
        const data = JSON.parse(request);
        const user = new AuthUser();
        user.sub = data.sub;
        user.roles = data.roles;
        user.currentCustomer = data.currentCustomer;
        user.loginCustomer = data.loginCustomer;
        user.exp = data.exp;
        user.iat = data.iat;
        user.aud = data.aud;
        user.iss = data.iss;
        user.username = data.username;
        return user;
    }

    getRolesEncoded(): string {
        let roleString = '';
        this.roles.forEach((role) => roleString += btoa(role) + ',');
        return btoa(roleString);
    }

    hasRole(role: string) {
        return this.roles.indexOf(role) !== -1;
    }

    hasAnyRole(roles: string[]) {
        let check = false;
        roles.forEach((role) => {
            if (this.hasRole(role)) {
                check = true;
            }
        });
        return check;
    }

    can(action: string, domain: string) {
        const checkRole = ConfigService.rolePrefix + ConfigService.roleDiv + action + ConfigService.roleDiv + domain;
        return this.hasRole(checkRole);
    }

    canRead(domain: string) {
        const checkRole = ConfigService.rolePrefix + ConfigService.roleDiv + ConfigService.roleReadOnly + ConfigService.roleDiv + domain;
        return this.hasRole(checkRole);
    }

    canManage(domain: string) {
        const checkRole = ConfigService.rolePrefix + ConfigService.roleDiv + ConfigService.roleManage + ConfigService.roleDiv + domain;
        return this.hasRole(checkRole);
    }


    getTokenAgeInSeconds(): number {
        const now = Math.round(new Date().getTime() / 1000);
        return (now - this.iat);
    }

    getTokenSecondsLeft(): number {
        const now = new Date().getTime();
        return Math.round(this.exp - (now / 1000));
    }

    doTokenExpiresWithinMinutes(minutes = 10): boolean {
        const now = new Date().getTime() / 1000;
        const treshold = minutes * 60;
        return this.exp - now < treshold;
    }

    isTokenExpired(): boolean {
        const now = new Date().getTime();
        return this.exp < (now / 1000);
    }

    isTokenIssuedBefore(date: Date): boolean {
        const now = new Date().getTime();
        return this.iat < (date.getTime() / 1000);
    }
    getIssuedAt(): number {
        return this.iat;
    }

    getPermissions(): string[] {
        const permissions = [];
        this.roles.forEach(role => {
            const parts = role.split('_');
            if (parts && parts.length > 2) {
                const text = parts[1].toLocaleLowerCase() + ' ' + parts[2].toLocaleLowerCase() + 's';
                permissions.push(text);
            }
        });
        return permissions;
    }

    verifyProjectRole(actionRole: string, userRole: string) {
        //console.log("UserRoleDef[userRole]: " + UserRoleDef[userRole] + " UserRoleDef[actionRole]: " + UserRoleDef[actionRole])
        return UserRoleDef[userRole] >= UserRoleDef[actionRole];
    }
}

enum UserRoleDef {
    PROJECT_ACCESS = 10,
    empty = -1
}

export class Customer {
    id: string;
    name: string;
    admin: boolean;
}
